import React from "react";
import "./percentageCellRenderer.scss";
import { numberFormatters } from "common";
import { NumberFormatKind } from "common/types";
export const DashablePercentageCellRenderer = (params) => {
    if (params.value === "-") {
        return React.createElement("span", null, "-");
    }
    if (!params.value && params.value !== 0) {
        return React.createElement("span", null, "-");
    }
    if ((params.value || params.value === 0) && !isNaN(params.value)) {
        return React.createElement("span", { className: "percentageCellRenderer" }, numberFormatters(params.value, NumberFormatKind.percent, { maximumFractionDigits: 2, minimumFractionDigits: 2 }));
    }
    return React.createElement("span", null, "-");
};
